import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/css/index.css"
import { Popup, RadioGroup, Radio } from 'vant';
// import VConsole from 'vconsole/dist/vconsole.min.js'
// new VConsole()
createApp(App)
.use(store)
.use(router)
.use(Popup)
.use(Radio)
.use(RadioGroup)
.mount('#app')
